export default __webpack_public_path__ + "static/media/m_foodieBooster12.cbf246c8.png";